import ColorService from 'Services/ColorService'

export default Circle = ({ color }) ->
  dotSize = 12
  dotRadius = dotSize / 2
  <svg
    width={dotSize}
    height={dotSize}
    style={{ lineHeight: 30, marginRight: 16, position: 'relative' }}
  >
    <circle
      cx={dotRadius}
      cy={dotRadius}
      r={dotRadius}
      fill={ColorService.getColorForType(color)}
    />
  </svg>
